import loadable from '@loadable/component';

export const LazyCatalogProductDetails = loadable(
  () =>
    import(
      /* webpackChunkName: "content/catalog/productdetails" */
      '.'
    ),
);
